(() => {
  const source = document.getElementById('component-registry');
  if (!source) return;

  let entries;
  try {
    entries = JSON.parse(source.textContent || '[]');
  } catch (error) {
    return;
  }

  let pending = entries.filter((entry) => Array.isArray(entry) && entry[0] && entry[1]);
  if (!pending.length) return;

  const load = (url) => {
    import(url).catch(() => {});
  };

  const scan = () => {
    const next = [];
    for (const entry of pending) {
      if (document.querySelector(entry[0])) load(entry[1]);
      else next.push(entry);
    }
    pending = next;
    return pending.length;
  };

  if (!scan()) return;

  let scheduled = false;
  let observer = null;

  const run = () => {
    scheduled = false;
    if (!scan() && observer) observer.disconnect();
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 400 });
    else setTimeout(run, 150);
  };

  observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', schedule, { once: true });
})();
